import {Component, ElementRef, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material';
import {AdyenService} from '@services/adyen.service';
import {FontAwesomeService} from '@services/font-awesome.service';
import {UserService} from '@services/user.service';
import {FormValidationService} from '@services/form-validation.service';
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs/Subject";
declare var adyen: any;

@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.scss']
})
export class AddCardComponent implements OnInit {
  initAdyen = false;
  submittedForm = false;
  form: FormGroup;
  private unsubscribe: Subject<void> = new Subject();

  @ViewChild('formData') public formData: ElementRef;
  @Output() getCard: EventEmitter<boolean> = new EventEmitter();
  public cardNumMask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
  public expDateMask = [/\d/, /\d/, '/', /\d/, /\d/];
  public cvcMask = [/\d/, /\d/, /\d/];
  constructor(private userService: UserService,
              public faService: FontAwesomeService,
              private _fb: FormBuilder,
              private formValidation: FormValidationService,
              private adyenService: AdyenService,
              public dialogRef: MatDialogRef<AddCardComponent>,) { }

  ngOnInit() {
    this.initializeForm();
    this.form.get('expiryDate').valueChanges.subscribe(() => this.getExpiryDate());

    this.adyenService.initAdyen()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(this.adyenService.handleSubscribe(this.formData, this.form));
  }

  handleSave() {

    this.userService.setCard({ encrypted_data: this.adyenService.getEncryptedData(this.form.value)})
      .subscribe(() => {
        this.dialogRef.close();
      }, err => console.log(err));
  }

  getExpiryDate() {
    let expDate;
    const date = this.form.controls['expiryDate'];
    if (date.value !== null) {
      expDate = date.value;
    } else {
      expDate = '00/00';
    }
    const arrDate = expDate.split('/');
    const expiryYear = '20' + arrDate[1];
    this.form.controls['expiry_month'].setValue(arrDate[0]);
    this.form.controls['expiry_year'].setValue(expiryYear);
  }

  initializeForm() {
    this.form = this._fb.group({
      payment_card: ['', [Validators.required, this.formValidation.creditCardNumberSupportedValidator]],
      payment_card_holder_name: ['', [Validators.required, Validators.minLength(2)]],
      expiryDate: ['', [Validators.required, this.formValidation.isExpiryDateValid]],
      expiry_month: [''],
      expiry_year: [''],
      payment_cvc: ['', [Validators.required, Validators.minLength(3)]],
      adyenData: ['']
    });
  }

  getCreditCardType(jsonPayment, typeCard) {
    if(this.initAdyen) {
      let card = adyen.cardTypes.determine( '' );
      const cardNumber = jsonPayment.value.cardNumber.replace( /\D/g, '' );
      if ( cardNumber.length > 2 ) {
        card = adyen.cardTypes.determine( cardNumber );
        if (card.cardtype) {
          return card.cardtype == typeCard;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user-settings/add-card/add-card.component.ts